import {InputTextV2} from '@prtimes-basis/input';
import {
  type ChangeEvent,
  type Dispatch,
  type SetStateAction,
  useEffect,
  useState,
} from 'react';
import {useController} from 'react-hook-form';
import styles from './phone-number-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';

const phoneNumberFieldName = 'companyInfo.phoneNumber';

export function PhoneNumberField() {
  return (
    <FormField.Root name={phoneNumberFieldName}>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {getValues} = useCompanyRegistrationFormContext();
  const phoneNumberValue = getValues(phoneNumberFieldName);
  const [firstField, setFirstField] = useState(
    () => phoneNumberValue.split('-')[0],
  );
  const [secondField, setSecondField] = useState(
    () => phoneNumberValue.split('-')[1] || '',
  );
  const [thirdField, setThirdField] = useState(
    () => phoneNumberValue.split('-')[2] || '',
  );

  const {control, isError} = useFormField();
  const {field} = useController({control, name: phoneNumberFieldName});

  const onChange = (
    {target: {value}}: ChangeEvent<HTMLInputElement>,
    setStateFunction: Dispatch<SetStateAction<string>>,
  ) => {
    // 4桁以上は入力できない
    if (value.length > 4) return;

    setStateFunction(value);
  };

  // フォームに同期するエフェクト
  useEffect(() => {
    if (!firstField.trim() && !secondField.trim() && !thirdField.trim()) {
      field.onChange('');
      return;
    }

    field.onChange(
      `${firstField.trim()}-${secondField.trim()}-${thirdField.trim()}`,
    );
  }, [field, firstField, secondField, thirdField]);

  return (
    <div className={companyRegistrationPageStyles.phoneNumberField}>
      <InputTextV2
        ref={field.ref}
        required
        wrapperClassName={styles.input}
        value={firstField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='代表電話番号'
        onChange={(event) => {
          onChange(event, setFirstField);
        }}
      />
      <p
        role='presentation none'
        className={companyRegistrationPageStyles.presentation}
      >
        -
      </p>
      <InputTextV2
        required
        wrapperClassName={styles.input}
        value={secondField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='代表電話番号'
        onChange={(event) => {
          onChange(event, setSecondField);
        }}
      />
      <p
        role='presentation none'
        className={companyRegistrationPageStyles.presentation}
      >
        -
      </p>
      <InputTextV2
        required
        wrapperClassName={styles.input}
        value={thirdField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='代表電話番号'
        onChange={(event) => {
          onChange(event, setThirdField);
        }}
      />
    </div>
  );
}
